import { makeStyles } from '@material-ui/core';
import docLogo from './doc-logo-white.svg';

// DOC's white logo, taken from www.doc.govt.nz, over the DOC-green sidebar,
// with the portal name under it.
const useStyles = makeStyles({
  root: { display: 'flex', flexDirection: 'column', alignItems: 'flex-start' },
  img: { height: 40, width: 'auto' },
  name: {
    marginTop: 4,
    color: '#FFC51D',
    fontSize: 13,
    fontWeight: 700,
    letterSpacing: 0.3,
    whiteSpace: 'nowrap',
  },
});

export const LogoFull = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <img
        className={classes.img}
        src={docLogo}
        alt="Department of Conservation | Te Papa Atawhai"
      />
      <span className={classes.name}>Cloud Platform</span>
    </div>
  );
};
